import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import { Row, Col, Card, Tooltip, OverlayTrigger } from 'react-bootstrap';
// External libraries
import moment from 'moment';
// utils
import formatMoney from 'utils/formatMoney';
// components
import ShippingModal from './ShippingModal';

const ShippingCard = ({ data, index, setUpdatePage }) => {
  const [isModalAdOpen, setIsModalAdOpen] = useState(false);
  const [isModalOwOpen, setIsModalOwOpen] = useState(false);
  const { currentUser } = useSelector((state) => state.auth);
  return (
    <>
      {/* Modal Add Charges Start */}
      {isModalAdOpen && (
        <ShippingModal
          data={data}
          isModalOpen={isModalAdOpen}
          setIsModalOpen={setIsModalAdOpen}
          title="Cargos Adicionales"
          type="ad"
          setUpdatePage={setUpdatePage}
        />
      )}
      {isModalOwOpen && (
        <ShippingModal data={data} isModalOpen={isModalOwOpen} setIsModalOpen={setIsModalOwOpen} title="Sobrepeso" type="ow" setUpdatePage={setUpdatePage} />
      )}
      {/* Modal Add Charges End */}
      <div className="rounded-0 py-2 py-lg-0 ps-5 pe-4 h-100 shadow-none text-alternate border-bottom">
        <Row className="g-0 h-100 sh-lg-6 position-relative overflow-y-hidden">
          {/* <div className="lh-1 text-muted">{`${counter}.`}</div> */}
          <Col xs="12" lg="3" className="d-flex flex-column mb-lg-0  pe-3 d-flex   justify-content-center order-3 order-lg-1">
            <div className="text-muted text-small d-lg-none">Razón Social</div>
            {/* <OverlayTrigger delay={{ show: 800, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">Ver perfil</Tooltip>}></OverlayTrigger> */}
            <NavLink className="text-alternate d-flex justify-content-center" to={`/users-all/detail/${data?.crm_user}`}>
              {`${index + 1}. ${data.razon_social.toUpperCase()}`}
            </NavLink>
          </Col>

          <Col xs="6" lg="1" className=" d-flex flex-column pe-1 pe-lg-2 mb-2 mb-lg-0 justify-content-center order-last order-lg-2">
            <div className="text-muted text-small d-lg-none">Fecha / Hora</div>
            {/* creation_date:"2024-10-04T11:40:59.362067Z" */}

            <div className="text-alternate d-flex justify-content-center">{`${moment(data.creation_date).format('DD-MM-YY')} ${data?.creation_date.slice(
              11,
              19
            )}`}</div>
          </Col>

          <Col xs="12" lg="3" className="d-flex flex-column pe-1 mb-2 mb-lg-0 justify-content-center align-items-lg-center order-4 order-lg-3">
            <div className="text-muted text-small d-lg-none">ID Envío</div>
            <OverlayTrigger delay={{ show: 800, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">Ver detalle de envío</Tooltip>}>
              <NavLink
                className="text-alternate d-flex justify-content-center"
                to={`/shipping-all/detail/${data?.shipping_label_id}/${data?.razon_social}/${data?.crm_user}`}
              >
                {data?.shipping_label_id}
              </NavLink>
            </OverlayTrigger>
          </Col>

          <Col lg="3" className=" d-flex flex-column pe-1 mb-2 mb-lg-0 justify-content-center order-5 order-lg-4">
            <div className="text-muted text-small d-lg-none">Servicio</div>

            <div className="text-alternate d-flex justify-content-center">{data.shipping_code?.replace(/_+/g, ' ')}</div>
          </Col>
          <Col xs="6" lg="1" className="d-flex flex-column pe-1 mb-2 mb-lg-0 justify-content-center align-items-end order-last order-lg-5 text-end">
            <div className="text-muted text-small d-lg-none">Costo</div>
            <div className={`${data.refunded ? 'text-success' : 'text-primary'}`}>
              <span className="text-alternate d-flex justify-content-center">$ {formatMoney(data.shipping_rates?.total)}</span>

              <div className={`text-alternate d-flex justify-content-center ${data.refunded ? 'd-block' : 'd-none'}`}>Guía devuelta</div>
            </div>
          </Col>
          <Col
            xs="12"
            lg="1"
            className={`ps-4 d-flex mb-2 mb-lg-0 align-items-center justify-content-end order-1 order-lg-last ${
              currentUser.access !== 'Control Total' ? 'd-none' : 'd-flex'
            }`}
          >
            <div onClick={() => setIsModalAdOpen(true)}>
              <CsLineIcons icon="wallet" className="anchor-effect-primary me-2 cursor-pointer" />
            </div>
            <div onClick={() => setIsModalOwOpen(true)}>
              <CsLineIcons icon="warning-hexagon" className="anchor-effect-primary cursor-pointer" />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default ShippingCard;
